import React from 'react';
import styled from '@emotion/styled';
import { Box } from '@mui/material';
import breakpoints from '../Theme/breakpoints';
import CardWithText from './CardWithTextSkeleton';
import ListItemSkeleton from './ListItemSkeleton';
import Skeleton from './Skeleton';

const MostReadSkeleton = styled.div`
  display: flex;
  flex-direction: column;
  flex-basis: calc(100%);

  @media (min-width: ${breakpoints.md}px) {
    flex-wrap: wrap;
    flex-direction: row;
  }

  @media (min-width: ${breakpoints.lg}px) {
    flex-basis: calc(74%);
  }
`;

const Sidebar = styled.div`
  display: flex;
  flex-direction: column;
  flex-basis: 100%;

  @media (min-width: ${breakpoints.lg}px) {
    flex-basis: calc(26% - (24px - 1px));
    padding-left: 24px;
  }
`;

const SkeletonGroup = styled.div<{ bigCard? : boolean }>`
  @media (min-width: ${breakpoints.md}px) {
    padding: ${({ bigCard }) => (bigCard
    ? '0 1.5rem'
    : '0'
  )};

    flex-basis: ${({ bigCard }) => (bigCard
    ? 'calc(65% - 32px)'
    : 'calc(35% - (16px + 1px))'
  )};
  }
`;

const MostRead = styled.div`
  margin-top: 1rem;
`;

const BigCardImage = styled(Skeleton)`
  height: 66vw;

  @media (min-width: ${breakpoints.md}px) {
    height: 42vw;
  }

  @media (min-width: ${breakpoints.lg}px) {
    height: 22vw;
  }
`;

const Container = styled.div`
  display: flex;
  flex-wrap: wrap;
  width: 100%;
  max-width: 1440px;

  @media (min-width: ${breakpoints.lg}px) {
    flex-wrap: nowrap;
  }
`;

const LastArticle = styled.div`
  display: flex;
  flex-direction: column;
  flex-basis: calc(100% - 24px);
  margin: 2rem 0;

  @media (min-width: ${breakpoints.md}px) {
    flex-direction: row;
  }

  @media (min-width: ${breakpoints.lg}px) {
    order: 4;
  }
`;

const Text = styled.div`
  flex: 1;
`;

const Image = styled.div`
  flex: 1;
  min-height: 67vw;

  @media (min-width: ${breakpoints.md}px) {
    margin-left: 1.5rem;
    min-height: 42vw;
  }

  @media (min-width: ${breakpoints.md}px) {
    min-height: 18vw;
  }

  .MuiSkeleton-root {
    height: 100%;
  }
`;

const Header = styled.div`
  margin-bottom: 2rem;
`;

export const TextSkeletons = () => (
  <>
    <Skeleton animation="wave" />
    <Skeleton animation="wave" />
    <Skeleton animation="wave" />
  </>
);

const BigCard = () => (
  <Box>
    <BigCardImage
      animation="wave"
      variant="rectangular"
    />
    <Skeleton animation="wave" height={48} />
    <TextSkeletons />
  </Box>
);

const CardGroup = () => (
  <SkeletonGroup>
    <CardWithText>
      <TextSkeletons />
    </CardWithText>
    <CardWithText>
      <TextSkeletons />
    </CardWithText>
  </SkeletonGroup>
);

const HomePageSkeletonLoader = () => (
  <Container>
    <MostReadSkeleton>
      <CardGroup />
      <SkeletonGroup bigCard>
        <BigCard />
      </SkeletonGroup>
      <LastArticle>
        <Text>
          <Header>
            <Skeleton animation="wave" height={32} />
            <Skeleton animation="wave" height={32} />
            <Skeleton animation="wave" height={32} width="25%" />
          </Header>
          <TextSkeletons />
        </Text>
        <Image>
          <Skeleton variant="rectangular" animation="wave" />
        </Image>
      </LastArticle>
    </MostReadSkeleton>
    <Sidebar>
      <Skeleton animation="wave" height={250} />
      <MostRead>
        <ListItemSkeleton height={102} flexDirection="row-reverse" />
        <ListItemSkeleton height={102} flexDirection="row-reverse" />
        <ListItemSkeleton height={102} flexDirection="row-reverse" />
      </MostRead>
      <Skeleton animation="wave" height={250} />
    </Sidebar>
  </Container>
);

export default HomePageSkeletonLoader;
